export type StatusTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

const tones: Record<string, StatusTone> = {
  running: 'success', healthy: 'success', online: 'success', ready: 'success', active: 'success', completed: 'success', success: 'success', succeeded: 'success', up: 'success', done: 'success',
  failed: 'danger', error: 'danger', unhealthy: 'danger', offline: 'danger', dead: 'danger', down: 'danger',
  deploying: 'info', pending: 'info', queued: 'info', starting: 'info', restarting: 'info', in_progress: 'info', migrating: 'info', verifying: 'info', awaiting_gc: 'info', awaiting_cleanup: 'info',
  degraded: 'warning', outdated: 'warning', warning: 'warning', stopping: 'warning', rolled_back: 'warning',
  stopped: 'neutral', exited: 'neutral', paused: 'neutral', inactive: 'neutral',
};

// Statuses where work is actively happening (spinner). Waiting states (pending, queued, awaiting_gc) are excluded.
const activeStatuses = new Set(['deploying', 'starting', 'restarting', 'in_progress', 'migrating', 'verifying']);

const normalize = (status: string | null | undefined) => (status ?? '').trim().toLowerCase();

export function statusTone(status: string | null | undefined): StatusTone {
  return tones[normalize(status)] ?? 'neutral';
}

export function isActiveStatus(status: string | null | undefined): boolean {
  return activeStatuses.has(normalize(status));
}

export function statusLabel(status: string | null | undefined): string {
  const trimmed = status?.trim();
  return trimmed ? trimmed.replace(/_/g, ' ') : 'unknown';
}
